import styled from '@emotion/styled';

export default styled.span({
    color: '#109CF1'
});
